import React from "react";
import { Box, Button } from "@mui/material";

const FeedbackButtons = ({ feedback, onFeedback }) => (
  <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1, marginTop: 2 }}>
    <Button
      variant={feedback === "up" ? "contained" : "outlined"}
      color="success"
      onClick={() => onFeedback("up")}
    >
      👍
    </Button>
    <Button
      variant={feedback === "down" ? "contained" : "outlined"}
      color="error"
      onClick={() => onFeedback("down")}
    >
      👎
    </Button>
  </Box>
);

export default FeedbackButtons;